import { useEffect, useLayoutEffect, useState } from "react";
import { connect, useStore } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import useMedia from "use-media";
import commonUtil from "../../../common/commonUtil";
import { apiKeyCheck, versionGetApi } from "../../../const";
import { getPropertyList, getTempReserveInfo, makeHotelReservation } from '../../../const/RTCC';
import MessageConst from "../../../const/RTCC/messageConst";
import { useRtoaster } from "../../../hooks/useRtoaster";
import common from '../../../resources/RTCC/js/common/common';
import { Button } from "../../atoms/RTCC/button";
import { Label } from '../../atoms/RTCC/label';
import { BreadCrumb } from '../../molecules/RTCC/breadCrumb';
import { ErrorMassage } from "../../molecules/RTCC/errorMassage";
import { GuestConfirmList } from "../../molecules/RTCC/guestConfirmList";
import './../../../resources/RTCC/css/userInput/userInput.css';
import { FooterContainer } from './footerContainer';

const RtccUserInputConfirmContainer = (props) => {
    const {
        login,
        checkIn,
        checkOut,
        reserveInfo,
        setReserveInfo,
        feeInfo,
        stayInfo,
        searchParam,
        toUserInputInfo,
        setToUserInputInfo,
        toUserInputConfirmInfo,
        setToUserInputConfirmInfo,
        onChange,
    } = props;

    //レスポンシブ対応
    const isWidePhone = useMedia({ maxWidth: '480px' });
    const isWideTablet = useMedia({ maxWidth: '960px' });
    const [Phone, setPhone] = useState(false);
    const [Tablet, setTablet] = useState(false);
    const useMediaFlag = useMedia({ maxWidth: '480px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);

    const history = useHistory();
    const store = useStore();

    const [linkList, setLinkList] = useState([]);
    const [roomNum, setRoomNum] = useState(toUserInputInfo.roomNum);
    const [roomList, setRoomList] = useState(toUserInputConfirmInfo.roomInfo);
    const [tempReserveId, setTempReserveId] = useState("");

    // プロパティ一覧
    const [paymentMtd, setPaymentMtd] = useState([]);
    const [customerAge, setCustomerAge] = useState([]);
    const [custmerGender, setCustmerGender] = useState([]);

    // エラー情報
    const [errorInfo, setErrorInfo] = useState({ errorMessage: null, errorFlg: false, errorCode: 0 });

    let clickFlg = true;

    // rtoasterタグ生成
    let totalAdultNum = 0;
    let totalChildNum = 0;
    let totalChildAgeList = [];
    stayInfo.forEach(value => {
        totalAdultNum += Number(value.adultNum);
        totalChildNum += Number(value.childNum);
        if (value.ageList?.length) {
            totalChildAgeList.push(value.ageList.join(","));
        }
    })
    const customParam = {
        "hotelid": toUserInputInfo.hotelId,
        "packcd": toUserInputInfo.planId.split("_")?.[1],
        "roomid": toUserInputInfo.planId.split("_")?.[0],
        "packnam": toUserInputInfo.planName,
        "roomname": toUserInputInfo.roomType,
        "riyosyodat": searchParam.searchParam.startDate,
        "riyosaisyudat": searchParam.searchParam.endDate,
        "roomsu": toUserInputInfo.roomNum,
        "adultninzu": totalAdultNum,
        "childninzu": totalChildNum,
        "childage": totalChildAgeList.length ? totalChildAgeList.join(",") : ""
    }
    useRtoaster(history.location.pathname, customParam);

    useLayoutEffect(() => {
        // リフレッシュ対応
        let state = store.getState().login;
        let apiKey = null;
        if (Object.keys(state).length !== 0) {
            apiKey = state.apiKey;
        }
        if (apiKey === null) {
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
        if (apiKey) {
            common.doPost(apiKeyCheck, { apikey: apiKey }, afterApiKeyCheck);
        }
    })
    const afterApiKeyCheck = (res) => {
        if (!res.data) {
            console.log("バックからの戻り値false");
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
    }

    useEffect(() => {
        common.doPost(versionGetApi, {}, afterVerCheck);
        window.scroll({ top: 0, behavior: 'smooth' })
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
        // プロパティ一覧取得
        common.doPost(getPropertyList, { propertyTypeList: ["PAYMENT_MET", "CUSTOMER_AGE", "CUSTOMER_GENDER"] }, afterGetPropertyList);
        // 一時予約取得
        common.doPost(getTempReserveInfo, { loginId: login.memberCode, reserveId: toUserInputInfo.reserveId }, afterGetTempReserveInfo);
        setLinkList([{ path: "/reserve/top", label: "HOME" }, { path: "/reserve/rtcc/reservation", label: "RTCC予約" }, { path: "/reserve/rtcc/userInput", label: "お客様情報入力" }]);
    }, [useMediaFlag]);

    const afterVerCheck = (res) => {
        let flg = common.versionCheck(res.data.version);
        if (flg) {
            history.push("/reserve/login");
            return;
        }
    }

    const afterGetTempReserveInfo = (res) => {
        if (res.data && res.data.resultCode == 38) {
            window.scroll({ top: 0, behavior: 'smooth' });
            setErrorInfo({
                errorMessage: [res.data.errorMessage],
                errorFlg: true,
                errorCode: res.data.resultCode
            });
        }else if (res.data && res.data.reserve.length == 1) {
            setTempReserveId(res.data.reserve[0].reserveId);
        }
    }

    const afterGetPropertyList = (res) => {
        let data = res.data;
        if (data) {
            if (data.propertyInfoList && data.propertyInfoList.length != 0) {
                let propertyInfoList = data.propertyInfoList;
                propertyInfoList.map((value, index) => {
                    let dataList = [];
                    switch (value.propertyType) {
                        case "PAYMENT_MET":
                            value.propertyList.map((property, propertyIndex) => {
                                let obj = {};
                                if (propertyIndex == 0) {
                                    obj = { checked: true, text: property.propertyName, value: property.propertyId };
                                } else {
                                    obj = { checked: false, text: property.propertyName, value: property.propertyId };
                                }
                                dataList.push(obj);
                                if (property.propertyId == toUserInputConfirmInfo.paymentId) {
                                    setToUserInputConfirmInfo({ ...toUserInputConfirmInfo, paymentMethod: property.propertyName });
                                }
                            })
                            setPaymentMtd(dataList);
                            break;
                        case "CUSTOMER_AGE":
                            value.propertyList.map((property, propertyIndex) => {
                                let obj = {};
                                if (propertyIndex == 0) {
                                    obj = { id: property.propertyId, value: property.propertyName, selected: true };
                                } else {
                                    obj = { id: property.propertyId, value: property.propertyName, selected: false };
                                }
                                dataList.push(obj);
                            })
                            setCustomerAge(dataList);
                            break;
                        case "CUSTOMER_GENDER":
                            value.propertyList.map((property, propertyIndex) => {
                                let obj = {};
                                if (propertyIndex == 0) {
                                    obj = { checked: true, text: property.propertyName, value: property.propertyId };
                                } else {
                                    obj = { checked: false, text: property.propertyName, value: property.propertyId };
                                }
                                dataList.push(obj);
                            })
                            setCustmerGender(dataList);
                            break;
                        default:
                            break;
                    }
                })
            }
        } else {
            // エラー処理
        }
    }

    // 「戻る」ボタン押下時
    const onClickBack = () => {
        history.push("/reserve/rtcc/userInput", {locationInfo: history.location});
    }
    // 「この内容で予約する」ボタン押下時
    const onClickReserve = () => {
        if (clickFlg) {
            clickFlg = false
            const checkInDate = new Date(checkIn);
            const checkOutDate = new Date(checkOut);
            let request = {
                loginId: login.memberCode,
                reserveId: tempReserveId,
                stayInfo: {
                    hotelId: toUserInputConfirmInfo.hotelId,
                    planId: toUserInputConfirmInfo.planId,
                    paymentId: toUserInputConfirmInfo.paymentId,
                    paymentPrice: feeInfo.totalFee,
                    roomSum: toUserInputConfirmInfo.roomSum,
                    checkInDate: checkInDate.getFullYear() + "-" + (checkInDate.getMonth() + 1).toString().padStart(2, "0") + "-" + checkInDate.getDate().toString().padStart(2, "0"),
                    checkOutDate: checkOutDate.getFullYear() + "-" + (checkOutDate.getMonth() + 1).toString().padStart(2, "0") + "-" + checkOutDate.getDate().toString().padStart(2, "0"),
                    roomInfo: toUserInputConfirmInfo.roomInfo
                }
            }
            common.doPost(makeHotelReservation, request, afterMakeHotelReservation);
        }
    }

    const afterMakeHotelReservation = (res) => {
        let data = res.data;
        let completeFlg = toUserInputConfirmInfo.paymentMethod != "クレジットカード";
        if (data.resultCode == 0) {
            setErrorInfo({ errorMessage: null, errorFlg: false, errorCode: data.resultCode });
            setToUserInputInfo({ ...toUserInputInfo, reserveId: data.reserveId, searchReserveId: data.reserveId, completeFlg: completeFlg });
            history.push("/reserve/rtcc/reservationComplete");
        } else if (data.resultCode == 36) {
            window.scroll({ top: 0, behavior: 'smooth' });
            setErrorInfo({
                errorMessage: [data.errorMessage],
                errorFlg: true,
                errorCode: data.resultCode
            });
        } else {
            window.scroll({ top: 0, behavior: 'smooth' });
            setErrorInfo({
                errorMessage: [MessageConst.RESERVE_ERROR],
                errorFlg: true,
                errorCode: data.resultCode
            });
        }
    }

    const getroomGuestNum = () => {
        const room = [];
        toUserInputConfirmInfo.roomInfo.map((value, roomIndex) => {
            room.push(
                <div key={"room" + roomIndex}>
                    <div className="userInputConfirmPoepleNum" key={"room" + roomIndex}>
                        <ul style={styles.ulStyle}>
                            <li style={styles.liStyle}>
                                <Label
                                    label={(roomIndex + 1) + "部屋目"}
                                    className="inputTitleLabel"
                                />
                            </li>
                            <li style={styles.liStyle2}>
                                <div>
                                    <Label
                                        label={"大人 " + value.adultSum + "人"}
                                        className="rtcc_inputContentLabel"
                                    />
                                    {value.childSum > 0 ?
                                        <Label
                                            label={"こども " + value.childSum + "人"}
                                            className={"rtcc_inputContentLabel"}
                                        />
                                        : null}
                                    {/* <Label
                                        label={"こども（添い寝） " + value.childSleepingSum + "人"}
                                        className="rtcc_inputContentLabel"
                                    /> */}
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div style={styles.border2}></div>
                </div>
            );
        })
        return <>{room}</>;
    }
    const roomGuestNum = getroomGuestNum();

    return (
        <div className="userInputInnerWrapper">
            <BreadCrumb
                breadCrumbStyle={isWideTablet ? { display: "none" } : styles.breadCrumb}
                linkStyle={styles.link}
                linkList={linkList}
                lastLabel="入力内容確認"
                lastLabelClassName="lastLabel"
            />
            <div style={isWideTablet ? styles.breadCrumb2 : { display: "none" }}></div>
            {errorInfo.errorFlg && errorInfo.errorCode == 36 ? <>
                <div className="btnToReserveCompleteWrapper">
                    <div style={styles.errorDiv}>
                        <ErrorMassage data={errorInfo.errorMessage} />
                    </div>
                    <div className="backTopReserveConfirm">
                        <Link to={"/reserve/rtcc/reservation"} style={styles.bottomLink}>RTCC検索TOPへ戻る</Link>
                    </div>
                </div>
            </> : <>
                <ErrorMassage style={errorInfo.errorFlg ? styles.errorDivWhite : { display: "none" }} data={errorInfo.errorMessage} />
                <div className="stayInfoWrapper">
                    <Label label="宿泊情報" className="reserveConirmTitle3" />
                    <div className="userInputConfirmWrapper">
                        <div className="userInputConfirm2">
                            <ul style={styles.ulStyle}>
                                <li style={styles.liStyle}>
                                    <Label
                                        label="部屋数"
                                        className="inputTitleLabel"
                                    />
                                </li>
                                <li style={styles.liStyle2}>
                                    <Label
                                        label={toUserInputConfirmInfo.roomSum + "室"}
                                        className="rtcc_inputContentLabel"
                                    />
                                </li>
                            </ul>
                        </div>
                            <div style={styles.border2}></div>
                            {roomGuestNum}
                            <div className="userInputConfirmPoepleNum">
                                <ul style={styles.ulStyle}>
                                    <li style={styles.liStyle}>
                                        <Label
                                            label="お支払い旅行代金"
                                            className="inputTitleLabel"
                                        />
                                    </li>
                                    {feeInfo?.stayInfo?.length ?
                                        <li className="liPrice">
                                            {feeInfo.stayInfo.map(value =>
                                                <div>
                                                    <Label
                                                        className="inputTitleLabel2"
                                                        label={value.roomCount + "室目"}
                                                    />
                                                    {value.feeList.map(feeObj =>
                                                        <div className="rtccPriceFlex">
                                                            <Label
                                                                className="inputTitleLabel2"
                                                                label={commonUtil.getStringFromDateJpnRtcc(feeObj.stayDate)}
                                                            />
                                                            <Label
                                                                className="inputTitleLabel2"
                                                                label={"：￥" + feeObj.dayFee.toLocaleString()}
                                                            />
                                                        </div>
                                                    )}
                                                    <Label
                                                        className="userFeeRikisha"
                                                        label={"小計：￥" + value.roomFee.toLocaleString()}
                                                    />
                                                </div>
                                            )}
                                            <Label
                                                className="userFeeRikisha"
                                                label={feeInfo.totalFee ? "合計：￥" + feeInfo.totalFee?.toLocaleString() : "合計：¥0 "}
                                            />
                                        </li>
                                        :
                                        <li style={styles.liStyle2}>
                                            <Label
                                                label={feeInfo.totalFee ? "¥" + feeInfo.totalFee.toLocaleString() : "¥0"}
                                                className="inputContentLabel"
                                            />
                                        </li>
                                    }
                                </ul>
                            </div>
                        </div>
                    </div>
                <div className="borderWrapper">
                    <div style={isWideTablet ? styles.border3 : styles.border}></div>
                </div>
                <div className="paymentMethodWrapper">
                    <Label label="お支払い方法" className="paymentTitleLabel" />
                    <div className="userInputConfirmWrapper">
                        <div className="userInputConfirm">
                            <ul style={styles.ulStyle}>
                                <li style={styles.liStyle}>
                                    <Label
                                        label={paymentMtd.find(value => value.value == toUserInputConfirmInfo.paymentId) ?
                                            paymentMtd.find(value => value.value == toUserInputConfirmInfo.paymentId).text : ""}
                                        className="rtcc_inputContentLabel"
                                    />
                                </li>
                                <li style={styles.liStyle}></li>
                            </ul>
                        </div>
                    </div>
                </div>
                {/* 部屋情報入力フォーム */}
                <GuestConfirmList
                    roomList={roomList}
                    gender={custmerGender}
                    humanType={customerAge}
                    id={props.id}
                    titleClassName="titleLabel"
                    representFlg={false}
                    onClickBack={onClickBack}
                    ulStyle={styles.ulStyle}
                    ulStyleSp={styles.ulStyleSp}
                    ulStyle2={styles.ulStyle2}
                    liStyle={styles.liStyle}
                    liStyleSp={styles.liStyleSp}
                    liStyle2={styles.liStyle2}
                    liBtnStyle={styles.liBtnStyle}
                    borderStyle={styles.border}
                    borderStyle2={styles.border2}
                    responsiveFlg={isWideTablet}
                />
                <div className="borderWrapper">
                    <div style={isWideTablet ? styles.border3 : styles.border}></div>
                </div>
                <div className={isWideTablet ? "reserveConirmWrapperWide" : "reserveConirmWrapper"}>
                    <div className="userInput4">
                        <Label label="ご予約内容" className="reserveConirmTitle2" />
                        <div className="reservationContentsWrap">
                            <div className="reservationContents">
                                <Label
                                    label="施設名"
                                    className={isWidePhone ? "inputTitleLabelNarrow" : "inputTitleLabel"}
                                />
                                <Label
                                    label={toUserInputInfo.hotelName}
                                    className="rtcc_inputContentLabel"
                                />
                            </div>
                            <div className="reservationContents">
                                <Label
                                    label="宿泊プラン名"
                                    className={isWidePhone ? "inputTitleLabelNarrow" : "inputTitleLabel"}
                                />
                                <Label
                                    label={toUserInputInfo.planName}
                                    className="rtcc_inputContentLabel"
                                />
                            </div>
                            <div className="reservationContents">
                                <Label
                                    label="ご利用日程"
                                    className={isWidePhone ? "inputTitleLabelNarrow" : "inputTitleLabel"}
                                />
                                <Label
                                    label={toUserInputInfo.startDate + "\n" + "～" + "\n" + toUserInputInfo.endDate}
                                    className="rtcc_inputContentLabel"
                                />
                            </div>
                            <div className="reservationContents">
                                <Label
                                    label="お部屋タイプ"
                                    className={isWidePhone ? "inputTitleLabelNarrow" : "inputTitleLabel"}
                                />
                                <Label
                                    label={toUserInputInfo.roomType}
                                    className="rtcc_inputContentLabel"
                                />
                            </div>
                            <div className={toUserInputInfo.cancelDescriptions ? "reservationContents" : "hiddenItem"}>
                                <Label
                                    label="取消料"
                                    className={isWidePhone ? "inputTitleLabelNarrow" : "inputTitleLabel"}
                                />
                                <div className="rtcc_inputContentLabel">
                                    <Label
                                        label={MessageConst.CANCEL_DESCRIPTION_MESSAGE}
                                        className="rtcc_inputContentLabel"
                                    />
                                    <Label
                                        label={toUserInputInfo.cancelDescriptions}
                                        className="rtcc_inputContentLabel"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="btnToReserveCompleteWrapper">
                    <div className="confirmboxWrap">
                        <Button buttonText="戻る" className="btnBack" onClick={onClickBack} buttonClassName="serachBtnText" />
                        <Button
                            buttonText="この内容で予約する"
                            className="btnReserveOrCredit"
                            buttonClassName="serachBtnText"
                            onClick={onClickReserve} />
                    </div>
                    <div className="backTopReserveConfirm">
                        <Link to={"/reserve/rtcc/reservation"} style={styles.bottomLink}>RTCC検索TOPへ戻る</Link>
                    </div>
                </div>
            </>}
            <div style={styles.footer}>
                <FooterContainer className={"userInputFooterBase"} />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        checkIn: state.checkIn,
        checkOut: state.checkOut,
        group: state.group,
        room: state.room,
        human: state.human,
        course: state.course,
        detailCondition: state.detailCondition,
        startTime: state.startTime,
        login: state.login,
        kaiinken: state.kaiinken,
        area: state.area,
        country: state.country,
        city: state.city,
        reserveInfo: state.reserveInfo,
        feeInfo: state.feeInfo,
        stayInfo: state.stayInfo,
        searchParam: state.searchParam,
        toUserInputInfo: state.toUserInputInfo,
        toUserInputConfirmInfo: state.toUserInputConfirmInfo,
    };
};

const mapToDispatchToProps = (dispatch) => {
    return {
        setDetailCondition: (item) => {
            dispatch({ type: "DETAIL_CONDITION", payload: { detailCondition: item } })
        },
        setCourse: (item) => {
            dispatch({ type: "COURSE", payload: { course: item } })
        },
        setStartTime: (item) => {
            dispatch({ type: "START_TIME", payload: { startTime: item } })
        },
        setGroup: (item) => {
            dispatch({ type: "GROUP", payload: { group: item } })
        },
        setRoom: (item) => {
            dispatch({ type: "ROOM", payload: { room: item } })
        },
        setHuman: (item) => {
            dispatch({ type: "HUMAN", payload: { human: item } })
        },
        setSearchResult: (item) => {
            dispatch({ type: "SEARCH_RESULT", payload: item })
        },
        setKaiinken: (item) => {
            dispatch({ type: "KAIINKEN", payload: { kaiinken: item } })
        },
        setArea: (item) => {
            dispatch({ type: "AREA", payload: { area: item } })
        },
        setCountry: (item) => {
            dispatch({ type: "COUNTRY", payload: { country: item } })
        },
        setCity: (item) => {
            dispatch({ type: "CITY", payload: { city: item } })
        },
        setCheckIn: (item) => {
            dispatch({ type: "CHECKIN", payload: { checkIn: item } })
        },
        setCheckOut: (item) => {
            dispatch({ type: "CHECKOUT", payload: { checkOut: item } })
        },
        setReserveInfo: (item) => {
            dispatch({ type: "RESERVE_INFO", payload: { reserveInfo: item } })
        },
        setToUserInputInfo: (item) => {
            dispatch({ type: "TO_USERINPUT_INFO", payload: { toUserInputInfo: item } })
        },
        setToUserInputConfirmInfo: (item) => {
            dispatch({ type: "TO_USERINPUTCONFIRM_INFO", payload: { toUserInputConfirmInfo: item } })
        },
    };
}

export default connect(mapStateToProps, mapToDispatchToProps)(RtccUserInputConfirmContainer);

const styles = {
    firstRoomWrapper: {
        width: "80%",
        margin: "0px auto",
        backgroundColor: "#808080",
        padding: "10px 10% 10px 10%",
    },
    userInput: {
        display: "block",
        flexWrap: "wrap",
    },
    roomNum: {
        display: "flex",
        padding: "20px 0px 20px 0px",
        marginBottom: "20px",
        justifyContent: "space-between",
        borderBottom: "1px solid #bfbec5",
    },
    link: {
        display: "inline-block",
        padding: "3px",
        color: "white",
        fontSize: "small",
    },
    bottomLinkArea: {
        marginTop: "30px",
        paddingTop: "40px",
        textAlign: "center",
        borderTop: "1px solid #bfbec5",
    },
    bottomLink: {
        padding: "3px",
        color: "black",
        fontSize: "small",
    },
    breadCrumb: {
        display: "flex",
        color: "white",
        padding: "8px 0px 30px 0px",
    },
    breadCrumb2: {
        marginBottom: "30px",
    },
    breadCrumbArrow: {
        marginRight: "5px",
        marginLeft: "5px",
        marginTop: "1px",
        fontSize: "small",
    },
    footer: {
        width: "80%",
        padding: "30px 10%",
        whiteSpace: "nowrap",
        color: "white",
        fontWeight: "300",
    },
    genderWrap: {
        marginBottom: "20px",
    },
    gender: {
        display: "flex",
    },
    genderLabel: {
        margin: "0px 30px 0px 10px",
    },
    confirmbox: {
        width: "100%",
        display: "flex",
        borderTop: "1px solid rgb(191, 190, 197)",
        borderBotttom: "1px solid rgb(191, 190, 197)",
        padding: "30px 0px",
    },
    paymentOption: {
        display: "flex",
        marginTop: "20px",
    },
    fee: {
        display: "flex",
        justifyContent: "space-between",
    },
    pullDownArea: {
        display: "flex",
        alignItems: "center"
    },
    reservationInfo: {
        display: "flex",
        justifyContent: "space-between",
        margin: "20px 60px 20px 100px",
    },
    ulStyle: {
        padding: 0,
        width: "100%",
        height: "100%",
        display: "flex",
        margin: "0px auto 0px auto",
    },
    ulStyleSp: {
        padding: 0,
        width: "100%",
        height: "100%",
        display: "block",
        margin: "0px auto 20px auto",
    },
    ulStyle2: {
        padding: "5px 0px 5px 0px",
        width: "100%",
        height: "100%",
        display: "flex",
        margin: "0px auto 0px auto",
    },
    liStyle: {
        listStyle: "none",
        width: "50%",
        height: "50px",
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center"
    },
    liStyleSp: {
        listStyle: "none",
        width: "100%",
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center"
    },
    liStyle2: {
        listStyle: "none",
        width: "50%",
        height: "50px",
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center"
    },
    liPrice: {
        listStyle: "none",
        width: "50%",
        boxSizing: "border-box",
        alignItems: "center"
    },
    liBtnStyle: {
        listStyle: "none",
        width: "50%",
        height: "50px",
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center",
        justifyContent: "right",
        padding: "0px 20px 0px 0px",
    },
    border: {
        borderTop: "1px solid rgb(191, 190, 197)",
        width: "70%",
        margin: "0px auto"
    },
    border2: {
        borderTop: "1px solid rgb(191, 190, 197)",
        // width: "70%",
        margin: "0px 0px 0px 0px"
    },
    border3: {
        borderTop: "1px solid rgb(191, 190, 197)",
        width: "90%",
        margin: "0px auto"
    },
    errorDiv: {
        display: "block",
        color: "red",
        textAlign: "center",
        fontSize: "0.8rem",
        background: "rgba(255,255,255,0)",
        border: 0,
        fontWeight: "bold"
    },
    errorDivWhite: {
        display: "block",
        color: "red",
        textAlign: "center",
        fontSize: "0.8rem",
        background: "rgba(255,255,255,0.94)",
        border: 0,
        fontWeight: "bold"
    }
}